import { render, staticRenderFns } from "./HubInfoTabs.vue?vue&type=template&id=e33d2b74"
import script from "./HubInfoTabs.vue?vue&type=script&lang=ts"
export * from "./HubInfoTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports